import { render, staticRenderFns } from "./VisitSecuItemMgList.vue?vue&type=template&id=881947a8&scoped=true"
import script from "./VisitSecuItemMgList.vue?vue&type=script&lang=js"
export * from "./VisitSecuItemMgList.vue?vue&type=script&lang=js"
import style0 from "./VisitSecuItemMgList.vue?vue&type=style&index=0&id=881947a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881947a8",
  null
  
)

export default component.exports